import { AgAppConfigService } from '@ag/vc.ag-core/settings';
import { AgTranslateService } from '@ag/vc.ag-core/translate';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserSurveyService } from '../../modules/survey/services/user-survey.service';
import { BackendEventLogs, BeEvents, EventLogViewModel } from '../models/BackendEventLogExports';
import { FactoryhelperService } from './factoryHelper.service';
interface BackendResponse {
  Result: boolean;
}
@Injectable({
  providedIn: 'root'
})
export class BackendEventLogService {
  private loggingModel?: EventLogViewModel;
  private readonly apiUrl: string;
  private event = new BackendEventLogs();

  constructor(
    private readonly factoryhelperService: FactoryhelperService,
    private readonly translateService: AgTranslateService,
    private readonly userSurveyService: UserSurveyService
  ) { 
    this.apiUrl = AgAppConfigService.get<string>('applicativeApiUrl');
  }

  public logBackendEvents(eventType: BeEvents): void{
    const params = this.userSurveyService.getSurveyParams();

    if (params) {
      switch(eventType) { 
      case BeEvents.Login: { 
        this.loggingModel = {...this.event.SuccessfulLogin, PersonId: Number(localStorage.personId)}
        this.trackBackendEvents(this.loggingModel).subscribe();
        break;
      } 
      case BeEvents.NegativeAdvice: { 
        this.loggingModel = {...this.event.NegativeAdviceEvent, PersonId: Number(localStorage.personId), 
          PartnerCode: params.partnerId,
          QuoteDetailId: params.simulationId
        }
        this.trackBackendEvents(this.loggingModel).subscribe();
        break; 
      } 
      case BeEvents.ProductRecommendation: { 
        this.loggingModel = {...this.event.RecommendedFormulaEvent, PersonId: Number(localStorage.personId), 
          PartnerCode: params.partnerId,
          QuoteDetailId: params.simulationId
        }
        this.trackBackendEvents(this.loggingModel).subscribe(); 
        break; 
      }
      case BeEvents.EsignConfirmation: { 
        this.loggingModel = {...this.event.EsignConfirmationEvent, PersonId: Number(localStorage.personId), 
          PartnerCode: params.partnerId, 
          QuoteDetailId: params.simulationId
        }
        this.trackBackendEvents(this.loggingModel).subscribe();
        break; 
      }
      case BeEvents.SelectYongoProduct: { 
        this.loggingModel = {...this.event.SelectYongoProductEvent, PersonId: Number(localStorage.personId), 
          PartnerCode: params.partnerId, 
          QuoteDetailId: params.simulationId
        }
        this.trackBackendEvents(this.loggingModel).subscribe(); 
        break; 
      }
      case BeEvents.DefineAmount: { 
        this.loggingModel = {...this.event.DefineAmountEvent, PersonId: Number(localStorage.personId), 
          PartnerCode: params.partnerId, 
          QuoteDetailId: params.simulationId
        }
        this.trackBackendEvents(this.loggingModel).subscribe(); 
        break; 
      }
      case BeEvents.InvalidAge: { 
        this.loggingModel = localStorage.personId ? {...this.event.InvalidAge, PersonId: Number(localStorage.personId)} : {...this.event.InvalidAge, Uci: localStorage.uci}
        this.trackBackendEvents(this.loggingModel).subscribe(); 
        break; 
      }
      case BeEvents.NotBelgianResident: { 
        this.loggingModel = localStorage.personId ? {...this.event.NotBelgianResident, PersonId: Number(localStorage.personId)} : {...this.event.NotBelgianResident, Uci: localStorage.uci}
        this.trackBackendEvents(this.loggingModel).subscribe(); 
        break; 
      }
      case BeEvents.NissExpired: { 
        this.loggingModel = localStorage.personId ? {...this.event.NissExpired, PersonId: Number(localStorage.personId)} : {...this.event.NissExpired, Uci: localStorage.uci}
        this.trackBackendEvents(this.loggingModel).subscribe(); 
        break; 
      }
      case BeEvents.NissExpiryMissing: { 
        this.loggingModel = localStorage.personId ? {...this.event.NissExpiryMissing, PersonId: Number(localStorage.personId)} : {...this.event.NissExpiryMissing, Uci: localStorage.uci}
        this.trackBackendEvents(this.loggingModel).subscribe(); 
        break; 
      }
      default: {
        break; 
      }
      } 
    }
  }

  private trackBackendEvents(logObject: EventLogViewModel): Observable<boolean>{
    const culture = this.translateService.currentLang;
    const url = `${this.apiUrl}/${culture}/silcommon/eventlog`;
    return this.factoryhelperService.post<BackendResponse>(url, logObject).pipe(
      map(x => x.Result) // TODO check to remove the any casting here
    );
  }
}
